import { previewArguments } from '../../shogun/platform-call-preview';

interface PlatformCallArgumentsPreviewProps {
  resource: string;
  method: string;
  args: Record<string, unknown> | null;
  testId: string;
  className: string;
}

export function PlatformCallArgumentsPreview({
  resource,
  method,
  args,
  testId,
  className,
}: PlatformCallArgumentsPreviewProps) {
  if (args === null) {
    return (
      <p data-testid={`${testId}-unavailable`} className="text-micro text-muted-foreground">
        The arguments of this call are not available to preview.
      </p>
    );
  }
  return (
    <pre data-testid={testId} className={className}>
      {JSON.stringify(previewArguments(resource, method, args), null, 2)}
    </pre>
  );
}
